import { t } from 'i18next';

export function packageVersionFormat(planVersion: number, isLatest?: boolean | null) {
  return `${t('packages.versionPrefix')}${planVersion}${isLatest ? ' (Latest)' : ''}`;
}
